export { default } from "./ProfileLayout";
